<div class="d-flex justify-content-between">
    <div class="card-sub-heading my-3">Rx Details</div>
    <button mat-icon-button (click)="this.dialogRef.close()" type="button">
        <img src="assets/images/icons/grey_cross_icon.png" alt="close icon" />
    </button>
</div>

<hr>

<form [formGroup]="rxForm">
<div class="row">
        <div class="col-8 mb-3">
            <label class="small white-space pb-1">Rx ID</label>
            <div class="form-group">
                <input type="text" class="form-control" formControlName="rxId" placeholder="Enter Rx ID"
                    (keypress)="keyPressNumbers($event)" (keyup)="verify_rx_btn = false"/>
                <mat-error class="ml-3"
                *ngIf="rxForm.get('rxId')?.hasError('required') && rxForm.get('rxId')?.touched">
                Rx ID is required.
            </mat-error>
            </div>
        </div>

        <div class="col-4">
            <label class="small white-space pb-1">&nbsp;</label>
            <div class="form-group">
                <button class="custom-btn custom-btn1" type="button" (click)="verifyRXDetail()" [disabled]="verify_rx_btn || rxForm.invalid">
                    Verify Rx
                    <!-- <span class="whiteLoader" *ngIf="isProcessOrderLoading">&nbsp;</span> -->
                </button>
            </div>

        </div>

        <div class="col-6 mb-3">
            <label class="small white-space pb-1">Quantity</label>
            <div class="form-group">
                <input type="text" class="form-control" formControlName="qnt" placeholder="-" readonly />
            </div>
        </div>

        <div class="col-6 mb-3">
            <label class="small white-space pb-1">Drug Name</label>
            <div class="form-group">
                <input type="text" class="form-control" formControlName="drgName" placeholder="-" readonly />
            </div>
        </div>

        <div class="col-6 mb-3">
            <label class="small white-space pb-1">DIN</label>
            <div class="form-group">
                <input type="text" class="form-control" formControlName="din" placeholder="-" readonly />
            </div>
        </div>

        <div class="col-6 mb-3">
            <label class="small white-space pb-1">Fill Date</label>
            <div class="form-group">
                <input type="date" class="form-control" formControlName="fillDate" placeholder="-" readonly />
            </div>
        </div>

        <div class="col-12 text-center">
            <button class="custom-btn custom-btn2" type="button" (click)="addRxDetails()" [disabled]="isSaveRxDetails || isSaveRXLoading" >
                {{isSaveRXLoading ? 'Saving Details... ' : 'Save Details '}}
                <span class="whiteLoader" *ngIf="isSaveRXLoading">&nbsp;</span>
            </button>
        </div>
    </div>
</form>